
/**
 * @roxi/routify 2.15.1
 * File generated Fri Apr 16 2021 17:01:32 GMT+0000 (Coordinated Universal Time)
 */

export const __version = "2.15.1"
export const __timestamp = "2021-04-16T17:01:32.652Z"

//buildRoutes
import { buildClientTree } from "@roxi/routify/runtime/buildRoutes"

//imports


//options
export const options = {}

//tree
export const _tree = {
  "root": true,
  "children": [
    {
      "isIndex": true,
      "isPage": true,
      "path": "/index",
      "id": "_index",
      "component": () => import('../src/pages/index.svelte').then(m => m.default)
    }
  ],
  "path": "/"
}


export const {tree, routes} = buildClientTree(_tree)

